const NON_PROPERTY_MEDIA_MARKERS = ["/bank-rates/", "ctfoodnex", "_icon.", "webicon", "/logos/", "group1765", "cookie", "banner", "thumbnail", "thumb", "qrcode", "qr-code", "brochure", "contact-card"];
const NON_PROPERTY_MEDIA_PATTERNS = [/(?:^|[/_-])(icon|logo|banner|thumb(?:nail)?|qrcode|qr-code|contact)(?:[._/-]|$)/i];
const VALID_IMAGE_EXTENSION_PATTERN = /\.(jpe?g|png|webp)(?:$|\?)/i;

export const isLikelyPropertyMedia = (url = "") => {
  const normalized = String(url || "").trim().toLowerCase();
  if (!normalized) return false;
  if (normalized.includes("res.cloudinary.com/") && normalized.includes("/image/upload/")) {
    return !NON_PROPERTY_MEDIA_MARKERS.some((marker) => normalized.includes(marker)) && !NON_PROPERTY_MEDIA_PATTERNS.some((pattern) => pattern.test(normalized));
  }
  if (!VALID_IMAGE_EXTENSION_PATTERN.test(normalized)) return false;
  return !NON_PROPERTY_MEDIA_MARKERS.some((marker) => normalized.includes(marker)) && !NON_PROPERTY_MEDIA_PATTERNS.some((pattern) => pattern.test(normalized));
};

export const sanitizeMediaCollection = (urls = []) => {
  const seen = new Set();
  return urls.filter((url) => {
    const normalized = String(url || "").trim();
    if (!isLikelyPropertyMedia(normalized) || seen.has(normalized)) return false;
    seen.add(normalized);
    return true;
  });
};

export const getVirtualStagingPair = ({ beforeImage, afterImage }) => {
  const validatedBefore = isLikelyPropertyMedia(beforeImage) ? beforeImage : null;
  const validatedAfter = isLikelyPropertyMedia(afterImage) ? afterImage : null;
  if (!validatedBefore || !validatedAfter) {
    return { beforeImage: null, afterImage: null };
  }
  return { beforeImage: validatedBefore, afterImage: validatedAfter };
};